// extracted by mini-css-extract-plugin
module.exports = {"centerDisplay":"PolicyLiabilityComponent_centerDisplay__3NLQE"};